export default [
  {
    key: 'personal-information',
    title: 'common.profileSection.personalInformation',
    icon: 'account_circle',
  },
  {
    key: 'email-alias',
    title: 'common.profileSection.emailAlias',
    icon: 'fa-envelope',
  },
  {
    key: 'password',
    title: 'common.profileSection.password',
    icon: 'fa-key',
  },
  {
    key: 'identity-checking',
    title: 'common.profileSection.identityChecking',
    icon: 'id_card',
  },
  {
    key: 'settings',
    title: 'common.profileSection.settings',
    icon: 'fa-gear',
  },
]
